import { useEffect } from 'react'

const useSubmitOnEnter = (onSubmit: () => void): void => {
  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.code === 'Enter') {
        onSubmit()
      }
    }

    document.addEventListener('keydown', listener)

    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [onSubmit])
}

export default useSubmitOnEnter
